// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apex-custom-label title,.apex-custom-label tspan{font-family:Vazir,serif!important}", ""]);
// Exports
module.exports = exports;
